import React, {Component} from 'react';
import {InputItem, Modal, NavBar, Toast} from 'antd-mobile';
import "./style.less";
import {connect} from "react-redux";
import SelectBank from '../../../../components/SelectBank'
import TestCode from '../../../../components/TestCode'
import {walletRecharge, walletWithdraw, walletCode,} from "../../../../service/homeService"

@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Recharge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            price:"",
            typeVal:"",
            bankModal:false,
            codeModal:false,
            getCodeDisabled: false,
            getCodeText: '重新获取',
            bankSel:"",
            bankChange:"",
        };
    }
    componentDidMount(){
        // this.textInput.focus();
        if(this.props.location.state.type == "recharge"){
               this.setState({typeVal:"充值"})
        }
        if(this.props.location.state.type == "out"){
            this.setState({typeVal:"提现"})
        }

    }
    inputChange = key =>(e) =>{
        if(e == "."){
            return
        }
        if(e.length > 1 && e[0] == 0 && e[1] !== "."){
            return
        }
        if(e[0] == 0 && e.length > 4){
            return
        }
        this.setState({ [key]: e})
    };
    onClose = () => {
        this.setState({bankModal:false,codeModal:false});
    };
    codeSubmit(v){
        if(v == ""){
            Toast.info("请输入验证码");
            return
        }
        this.setState({codeModal:false,});
        let params ={
            token:this.props.userInfo.token,
            source:1,
            data:{
                bankNumber:this.state.bankChange.bankNumber,
                smsCode:v,
                amount:parseFloat(this.state.price).toFixed(2)
            },
        };
        console.log(params,v);
        // return
        Toast.loading("",0);
        let wallet = "";
        if(this.state.typeVal == "充值"){
            wallet = walletRecharge
        }else if(this.state.typeVal == "提现"){
            wallet = walletWithdraw
        }
        wallet(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setState({getCodeText: '重新获取'});
                Toast.info(`${this.state.typeVal}延迟到账，具体以短信为准`,2,()=> this.props.history.goBack())
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    // 倒数计时
    setDownTime = (time) => {
        let timer = setInterval(() => {
            time--;
            if (time > 0) {
                this.setState({getCodeDisabled: true,getCodeText: time + 's后获取'});
            } else {
                this.setState({getCodeText: '重新获取'});
                this.setState({getCodeDisabled: false});
                clearInterval(timer);
            }
        }, 1000);
    };
    getCode(){
        let params={
            token:this.props.userInfo.token,
            source:1,
            data:{
                source:this.state.typeVal == "充值" ? 1 :2,
            }
        };
        walletCode(params).then((res)=>{
            if(res.data.code === '0000'){
                this.setDownTime(60);
                this.setState({codeModal:true});
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    changeBank(v){
        this.setState({
            bankSel:`${v.bankName}(${v.bankNumber.substring(v.bankNumber.length-4)})`,
            bankModal:false,
            bankChange:v
        })
    }
    submit(){
        if(this.state.price == ""){
            Toast.info(`请输入${this.state.typeVal}额度`);
            return
        }
        if(this.state.price <= 0){
            Toast.info(`请金额大于0`);
            return
        }
        if(this.state.typeVal == "提现" && parseFloat(this.state.price).toFixed(2) > parseFloat(this.props.location.state.balance).toFixed(2)){
            Toast.info(`可提现金额不足`);
            return
        }
        if(this.state.bankSel == ""){
            Toast.info(`请选择${this.state.typeVal}银行`);
            return
        }
        console.log(parseFloat(this.state.price).toFixed(2))
        console.log(this.props.location.state.balance)
        if(this.state.getCodeText == "重新获取"){
            this.getCode()
        }else {
            Toast.info(this.state.getCodeText,3)
        }
    }
    render(){
        return(
            <div className="recharge">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >{this.state.typeVal}</NavBar>
                <div className="content">
                    <div className="priceBox">
                        <p>{this.state.typeVal}金额</p>
                        <InputItem
                            // ref={(input) => { this.textInput = input; }}
                            clear
                            moneyKeyboardAlign="left"
                            type="money"
                            className="inp"
                            placeholder={`请输入${this.state.typeVal}的金额`}
                            value={this.state.price}
                            onChange={this.inputChange("price")}
                            onBlur={v => window.scroll(0,0)}
                            onVirtualKeyboardConfirm={v => console.log('金额', v)}
                        >￥</InputItem>
                        {this.state.typeVal == "提现" ? <div className="tixian">
                            可提现金额 <span>{'￥'+ this.props.location.state.balance}</span> <span className="txBtn" onClick={()=>this.setState({price:this.props.location.state.balance})}>全部提现</span>
                        </div>: null}
                    </div>
                    <div className="mode" onClick={()=>this.setState({bankModal:true})}>
                        <div>{this.state.typeVal == "充值" ? "充值方式" : "提现到"}</div>
                        <span>{this.state.bankSel}</span>
                        <i className="icon iconfont icontiaozhuan2"/>
                    </div>
                    <div className="btn" onClick={()=>this.submit()}>{this.state.typeVal}</div>
                </div>
                <TestCode
                    modal={this.state.codeModal}
                    onClose={this.onClose.bind(this)}
                    againEvent={this.getCode.bind(this)}
                    getCodeDisabled={this.state.getCodeDisabled}
                    getCodeText={this.state.getCodeText}
                    codeSubmit={this.codeSubmit.bind(this)}
                />
                <SelectBank
                    modal={this.state.bankModal}
                    onClose={this.onClose.bind(this)}
                    changeBank={this.changeBank.bind(this)}
                    {...this.props}
                    // payType={this.payType.bind(this)}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/Wallet/Recharge/index.js